import { useFormContext } from '@american-autonomy/ag-ui';

import FormGrid from 'components/FormGrid';
import FieldNameField from 'components/fields/FieldNameField';
import SelectClientFarmField from 'components/fields/SelectClientFarmField';

import useTranslation from './hooks/useTranslation';

import { FIELD_NAME_FIELD_NAME, TEST_ID } from './constants';
import type { FieldFormSchema, FieldPath, Props } from './types';

const FieldFormFields = <T extends FieldFormSchema>({
    children,
    namePrefix,
    testId = TEST_ID
}: Props<T>) => {
    const { control } = useFormContext<T>();
    const { FIELD_NAME_FIELD_PLACEHOLDER } = useTranslation();

    const fieldName = (name: keyof FieldFormSchema) =>
        (namePrefix ? `${namePrefix}.${name}` : String(name)) as FieldPath<T>;

    return (
        <FormGrid testId={testId}>
            <FieldNameField<T>
                control={control}
                isRequired={true}
                name={fieldName(FIELD_NAME_FIELD_NAME)}
                placeholder={FIELD_NAME_FIELD_PLACEHOLDER}
            />

            <SelectClientFarmField<T> isRequired={true} namePrefix={namePrefix} />

            {children}
        </FormGrid>
    );
};

export default FieldFormFields;
